import { offsetPaginationFieldPolicy } from '../../../utils/policies';
import type { TypePolicies } from '../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  Account: {
    fields: {
      availableAdobeImsGroupsWithFilter: {
        ...offsetPaginationFieldPolicy(['nameFilter'], 'adobeGroupId'),
      },
    },
  },
};
